import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "../../../redux/store";
import { proceedLoanOffer } from "../../../redux/slices/financer";
import { getLoanOfferMsg, getMessages } from "../../../redux/slices/loanOffers";
import CustomerLoanChat from "./CustomerLoanChat";
import FinancerListTable from "./FinancerListTable";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
export default function PendingQueries() {
  const { offerId } = useParams();
  const dispatch = useDispatch();
  const [messages, setMessages] = useState([]);
  const [conversations, setConversations] = useState([]);
  // const dataColumn = [
  //     {
  //       name: "Krishhh",
  //       amount: "1000",
  //       roi: "5",
  //       tenure: "3",
  //       status: "Completed",
  //     },
  //     {
  //       name: "Krishhh",
  //       amount: "1000",
  //       roi: "5",
  //       tenure: "3",
  //       status: "Pending",
  //     },
  //   ];

  const { isLoading, offerMsgs, isAgreed, loanDetails } = useSelector(
    (state) => state.loanOffers
  );

  useEffect(() => {
    dispatch(getLoanOfferMsg(offerId))
      .unwrap()
      .then((res) => {
        if (res.success) {
          setMessages(res?.financierOffers);
        }
      });

    dispatch(getMessages(offerId))
      .unwrap()
      .then((res) => {
        if (res.success) {
          setConversations(res?.offerMessages);
        }
      });
  }, []);

  return (
    <div className="myaccount-content">
      <div className="d-flex flex-row-reverse align-items-center">
        <Link
          to={`/user/loan-scorecard/${loanDetails?.loan_id}`}
          className="text-primary fs-18 fw-500"
        >
          <i className="far fa-arrow-alt-circle-left"></i> Back
        </Link>
      </div>
      <div className="card my-3">
        <>
          {loanDetails !== null &&
            loanDetails !== undefined &&
            loanDetails !== "" && (
              <div
                style={{
                  paddingLeft: "1rem",
                  paddingRight: "1rem",
                  paddingTop: "1rem",
                }}
              >
                <div className="onboarding-title">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="onboard_flexhead d-flex justify-content-between align-items-center">
                        <h4 className="">Loan Information</h4>
                        {/* <div className="">
                          <div className="status btn">
                            <PendingIcon /> Pending
                          </div>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row align-items-center flex-row-reverse">
                  <div className="col-lg-12">
                    <div className="about-text go-to">
                      <div className="row about-list">
                        <div className="col-md-4">
                          <div className="media">
                            <label>Application ID:</label>
                            <p>{loanDetails?.loan_application_id}</p>
                          </div>
                          <div className="media">
                            <label>Financer :</label>
                            <p>{loanDetails?.financer?.name}</p>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="media">
                            <label> Loan type:</label>
                            <p>{loanDetails?.loan_type}</p>
                          </div>
                          {/* <div className="media">
                            <label>Amount:</label>
                            <p>
                              {
                                <CurrencyFormat
                                  value={user?.amount_requested}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  fixedDecimalScale={true}
                                  decimalScale={2}
                                />
                              }
                              &nbsp;
                              {currencySymbol()}
                            </p>
                          </div> */}
                        </div>
                        {/* <div className="col-md-4">
                          <div className="media">
                            <label>Tenure:</label>
                            <p>{user?.requested_tenure} Months</p>
                          </div>
                          <div className="media">
                            <label>Created Date :</label>
                            <p>{<LoanDate datestring={user?.created_at} />}</p>
                          </div>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
        </>
      </div>
      {/* <h4 className="mb-3">Query Section </h4> */}
      <div className="d-flex justify-content-between mb-3">
        {/* <div>
          <h4 className="">Discussion Section</h4>
        </div> */}
        {/* <div>
          <Link to="/loan-scorecard" className="text-primary fs-18 fw-500">
            <i className="far fa-arrow-alt-circle-left"></i> Back
          </Link>
        </div> */}
      </div>
      {/* <FinancerListTable offers={dataColumn}/> */}
      {isLoading ? (
        <SkeletonTheme highlightColor="#ffffff">
          <Skeleton width={`100%`} height={25} count={16} />
        </SkeletonTheme>
      ) : (
        <CustomerLoanChat
          messages={messages}
          offerId={offerId}
          isAgreed={isAgreed}
          setMessages={setMessages}
          conversations={conversations}
          setConversations={setConversations}
        />
      )}
    </div>
  );
}
